import React, { useState } from "react";
import "./styles.scss";
import { useHistory } from "react-router-dom";
import { Modal, Spinner } from "react-bootstrap";
import Actions from "../../../shared/Actions";
import { updatePlaylist, deletePlaylist } from "../../../../../api/playlists";
import { deleteAlbum, updateAlbum, distributeAlbum } from "../../../../../api/albums";
import { isSelfId } from "../../../../../api/helper";
import { log_error } from "../../../../../api";
import MusicGenres from "../../../shared/MusicGenres";
import defaultAlbumImg from "../../../../../public/images/default-alblum-img.png";
import hv_player_api from "../../../../../api/hv_player_api";
import PlayButton from "../../../../shared/Svg/PlayButton";
import Menu from "../../../PostsList/Post/PostHeader/Menu";
import { ReactComponent as EditIcon } from "../../../../../public/icons/nav/edit.svg";
import { ReactComponent as EmbedIcon } from "../../../../../public/icons/embedIcon.svg";
import { ReactComponent as DistributeIcon } from "../../../../../public/icons/distributeIcon.svg";
import confirmIcon from "../../../../../public/icons/playlist/confirm.png";
import discardIcon from "../../../../../public/icons/playlist/discard.png";
import EmbedModal from "../../../../shared/EmbedModal";
import PrimoSubscriptionModal from "../../../shared/PrimoSubscriptionModal";
import { isDistroEnabled } from "../../../../../helper/helper";
import RollOver from "../../../../RollOver";
import { useSelector } from "react-redux";
import get from "lodash/get";
import moment from "moment";

export default ({ list, setList, media }) => {
  if (!list) return null;
  const [subscribeModal, setSubscribeModal] = useState(false);
  const [distributeAlbumSuccess, setDistributeAlbumSuccess] = useState("");
  const [distributeAlbumError, setDistributeAlbumError] = useState("");
  const [errorState, setErrorState] = useState(null);
  let [confirmModal, setConfirmModal] = useState(false);
  let [isEditing, setEditing] = useState(false);
  let [title, setTitle] = useState(list.title);
  let [loading, setLoading] = useState(false);
  let hideConfirmModal = () => setConfirmModal(false);
  let showConfirmModal = () => setConfirmModal(true);
  let history = useHistory();
  const { current_user } = useSelector(({ current_user }) => ({
    current_user,
  }));
  const email = current_user && get(current_user, "email", null);
  const user_type = current_user && get(current_user, "user_type", null);
  const playMedium = () => {
    hv_player_api.playMediaWithSource(media[0], list);
  };

  const apiHelper = {
    deleteList: () => {
      return list.type === "Album" ? deleteAlbum(list.id) : deletePlaylist(list.id);
    },
    updateUserList: () => {
      return list.type === "Album" ? updateAlbum({ album: { id: list.id, title } }) : updatePlaylist({ playlist: { id: list.id, title } });
    },
  };

  const deleteList = async () => {
    try {
      await apiHelper.deleteList();
      history.goBack();
    } catch (error) {
      console.log(log_error(error));
    }
  };

  const updateUserList = async () => {
    setLoading(true);
    try {
      await apiHelper.updateUserList();
    } catch (err) {
      const errorValue = log_error(err)
        .map((error) => error.message)
        .join(",");
      setErrorState(errorValue);
      ignoreChanges();
    } finally {
      setEditing(false);
      setLoading(false);
    }
  };

  const ignoreChanges = () => {
    setEditing(false);
    setTitle(list.title);
  };
  const handleDistributeClick = async () => {
    if (current_user.is_subscribed_to_primo) {
      if (list.distributed_on_eveara && list.eveara_album_path) {
        window.open(list.eveara_album_path);
      } else {
        setLoading(true);
        try {
          const { status, data } = await distributeAlbum(list.id, "album");
          if (status === 200) setDistributeAlbumSuccess(data.success);
        } catch (error) {
          setDistributeAlbumError(log_error(error));
          console.log(log_error(error));
        } finally {
          setLoading(false);
        }
      }
    } else {
      setSubscribeModal(true);
    }
  };

  const { distribution_decline_msg } = list;

  return (
    <>
      <div>
        {distributeAlbumSuccess && <div className="alert alert-success" role="alert" dangerouslySetInnerHTML={{ __html: distributeAlbumSuccess }} />}
        {distributeAlbumError && (
          <div
            className="alert alert-danger"
            role="alert"
            dangerouslySetInnerHTML={{
              __html: distributeAlbumError || distribution_decline_msg,
            }}
          />
        )}
        {distribution_decline_msg &&
          process.env.REACT_APP_ENV === "development" &&
          distribution_decline_msg?.includes("clean as parental advisory") && (
            <div
              className="alert alert-danger"
              role="alert"
              dangerouslySetInnerHTML={{
                __html: distributeAlbumError || distribution_decline_msg,
              }}
            />
          )}
      </div>
      <div className="media playlist_header overflow-hidden mb-4">
        <div className="position-relative mr-4">
          <img src={list.preview_image ? list.preview_image.url : defaultAlbumImg} alt={list.title} className="preview_image rounded" />
          <div className="position-absolute controls">
            <PlayButton className="play-button" onClick={playMedium} />
          </div>
        </div>
        <div className="media-body flex-grow-1 overflow-hidden">
          <div className="d-flex w-100 justify-content-between">
            <div className="w-75 pr-4">
              {isEditing ? (
                <input
                  disabled={loading}
                  onChange={(e) => setTitle(e.target.value)}
                  type="text"
                  className="form-control username"
                  placeholder="playlist title"
                  defaultValue={title}
                />
              ) : (
                <h1 className="text-black playlist-title">{title}</h1>
              )}
              <p className="text-dark font-weight-bold">{list.user.username}</p>
            </div>
            <div className="playlist-action d-none d-md-flex">
              {list.type !== "Playlist" && isSelfId(list.user.id) && isDistroEnabled(email, user_type) && (
                <>
                  {loading ? (
                    <Spinner variant="primary" animation="border" role="status" className="mr-3" />
                  ) : (
                    <RollOver className="playlist" text="DISTRIBUTE">
                      <DistributeIcon className="destribute-icon mr-3" onClick={handleDistributeClick} />
                    </RollOver>
                  )}
                </>
              )}
              {subscribeModal && (
                <PrimoSubscriptionModal
                  showModal={subscribeModal}
                  setSubscribeModal={setSubscribeModal}
                  albumId={list.id}
                  setDistributeAlbumSuccess={setDistributeAlbumSuccess}
                  setDistributeAlbumError={setDistributeAlbumError}
                />
              )}
              <EmbedModal object={list}>
                <RollOver className="playlist" text={`embed ${list.type}`}>
                  <EmbedIcon className="embed-icon mr-3" />
                </RollOver>
              </EmbedModal>
              {isEditing ? (
                <div className="d-flex">
                  <img onClick={ignoreChanges} src={discardIcon} className="actions-icon mr-2" alt="" />
                  <img onClick={updateUserList} src={confirmIcon} className="actions-icon" alt="" />
                </div>
              ) : (
                <>
                  <Menu object={list} type={list.type} userId={list.user.id} objectDeleter={showConfirmModal} />
                  {isSelfId(list.user.id) && <EditIcon onClick={setEditing} className="edit-icon ml-3" />}
                </>
              )}
            </div>
          </div>
          {errorState && <div className="alert alert-danger">{errorState}</div>}
          <Modal aria-labelledby="contained-modal-title-vcenter" show={confirmModal} onHide={hideConfirmModal}>
            <Modal.Body>
              <div className="p-5 text-center">
                <p className="font-weight-bold">ARE YOU SURE YOU WANT TO</p>
                <p className="font-weight-bold mb-5 text-uppercase">DELETE THIS {list.type}?</p>
                <div className="d-flex justify-content-between">
                  <button onClick={hideConfirmModal} className="text-uppercase btn btn-lg btn-outline-primary">
                    cancel
                  </button>
                  <button onClick={deleteList} className="text-uppercase btn btn-lg btn-primary">
                    delete
                  </button>
                </div>
              </div>
            </Modal.Body>
          </Modal>
          <Actions object={list} setObject={setList} />
          {list.type !== "Album" && (
            <div className="my-2">{list.tags && <MusicGenres defaultChecked={list.tags} onChange={() => {}} disabled filterBy="selected" />}</div>
          )}
          <br />
          {list.type == "Album" && (
            <span className="date" style={{ color: "#666666" }}>
              Release Date: {moment(list.release_date).format("MMMM DD, YYYY")}
            </span>
          )}
        </div>
      </div>
    </>
  );
};
